export const experience = [
  {
    title: "آپ‌تایم تضمین‌شده",
    desc: "دسترسی پایدار و مداوم به سرورها و سرویس‌ها",
    logo: "disaster.svg",
    imgAlt: "آپ‌تایم تضمین‌شده",
    imgTitle: "آپ‌تایم تضمین‌شده",
  },
  {
    title: "امنیت چند لایه",
    desc: "با سیستم‌های حفاظتی و نظارت ۲۴ ساعته",
    logo: "startup.svg",
    imgAlt: "امنیت چند لایه",
    imgTitle: "امنیت چند لایه",
  },
  {
    title: "مانیتورینگ سلامت زیرساخت",
    desc: "پایش لحظه‌ای وضعیت برق، دما و عملکرد تجهیزات",
    logo: "virtualOrganization.svg",
    imgAlt: "مانیتورینگ سلامت زیرساخت",
    imgTitle: "مانیتورینگ سلامت زیرساخت",
  },
  {
    title: "تامین انرژی پایدار",
    desc: "زیرساخت برق چند‌لایه و مقاوم در برابر قطع شدن",
    logo: "test.svg",
    imgAlt: "تامین انرژی پایدار",
    imgTitle: "تامین انرژی پایدار",
  },
];

export const services = [
  {
    title: "سرور اختصاصی Bare Metal",
    specialChar: "",
    desc: "آبالون منابع سخت‌افزاری را به‌صورت Bare Metal در اختیار شما قرار می‌دهد تا بتوانید معماری دلخواه سازمان خود را بدون لایه‌های اضافی روی سرورها پیاده‌سازی کنید.",
  },
  {
    title: "کولوکیشن Bare Metal",
    specialChar: "",
    desc: "تجهیزات سخت‌افزاری سازمان شما، در دیتاسنتر‌های آبالون به‌صورت Bare Metal مستقر می‌شود تا در محیطی امن، امکان بهره‌برداری حداکثری از معماری اختصاصی سازمان را فراهم شود.",
  },
  {
    title: "سرور اختصاصی ابری",
    specialChar: "",
    desc: "با مدل سرور اختصاصی ابری،  متخصصان آبالون معماری ابری را روی تجهیزات پیاده‌سازی می‌کنند تا با استفاده از پنل OpenStack،  زیرساخت منعطف ابری را تجربه کنید.",
  },
  {
    title: "کولوکیشن ابری",
    specialChar: "",
    desc: "کولوکیشن ابری، این امکان را به شما می‌دهد تا معماری ابری را روی تجهیزات سازمانی خود تجربه کنید. در این مدل با حفظ مالکیت سخت‌افزار از مزایای زیرساخت ابری بهره‌مند می‌شوید.",
  },
];

export const popularServices = [
  {
    title: "محصولات آبالون",
    desc: "با استفاده از محصولات ابری و دیتاسنتری آبالون، زیرساخت امن، پایدار و مقیاس‌پذیر سازمان‌تان را بدون پیچیدگی‌های فنی ایجاد کنید.",
    logo: "VPS-Service.svg",
    route: "/products",
    imgAlt: "محصولات آبالون",
    imgTitle: "محصولات آبالون",
  },
  {
    title: "امنیت ابری",
    desc: "با استفاده از راهکارهای امنیتی پیشرفته مانند فضای کاری امن، فایروال ابری، WAF و سامانه SIEM از سرویس‌های سازمانی خود در فضای ابری محافظت کنید.",
    logo: "CloudGuard-Service.svg",
    route: "/cloud-security",
    imgAlt: "امنیت ابری",
    imgTitle: "امنیت ابری",
  },
  {
    title: "سرویس‌های مدیریت شده",
    desc: "تحت سرویس‌های مدیریت شده، راهکارهای اختصاصی سازمان شما در حوزه ابری، از جمله نصب سیستم‌عامل و نرم‌افزار، طراحی معماری و مهاجرت ابری اجرا می‌شود.",
    logo: "VPC-Service.svg",
    route: "/devops",
    imgAlt: "سرویس‌های مدیریت شده",
    imgTitle: "سرویس‌های مدیریت شده",
  },
  {
    title: "شبکه ابری آبالون",
    desc: "با شبکه ابری آبالون، ترافیک سازمان‌تان را بهینه مدیریت کنید، محدودیت‌های دسترسی را برطرف کنید و اتصال پایدار و امن را تجربه کنید.",
    logo: "ManagedService-Service.svg",
    route: "/network",
    imgAlt: "شبکه ابری آبالون",
    imgTitle: "شبکه ابری آبالون",
  },
];

export const questions = [
  {
    title: "خدمات دیتاسنتر آبالون شامل چه سرویس‌هایی می‌شود؟",
    answer:
      "خدمات دیتاسنتر آبالون شامل سرور اختصاصی و سرویس کولوکیشن است. این سرویس‌ها امکان دسترسی به منابع سخت‌افزاری قدرتمند یا استقرار تجهیزات سازمانی در دیتاسنترهای پیشرفته آبالون را با امنیت بالا و پایداری تضمین‌شده فراهم می‌کنند.",
  },
  {
    title: "تفاوت سرور اختصاصی و کولوکیشن در دیتاسنتر آبالون چیست؟",
    answer:
      "به‌عنوان بخشی از خدمات دیتاسنتر آبالون، در سرویس سرور اختصاصی، منابع سخت‌افزاری توسط آبالون تأمین و متناسب با نیاز شما سفارشی‌سازی می‌شود. در سرویس کولوکیشن، تجهیزات متعلق به سازمان شما در مراکز داده آبالون مستقر می‌شود و زیرساخت ایمن و پایدار دیتاسنتر از آنها میزبانی می‌کند.",
  },
  {
    title: "آیا امکان انتخاب موقعیت جغرافیایی دیتاسنتر وجود دارد؟",
    answer:
      "بله. آبالون دیتاسنترهای خود را در نقاط کلیدی ایران مستقر کرده است تا بتوانید بر اساس نیاز خود، نزدیک‌ترین دیتاسنتر را برای دسترسی با کمترین تأخیر انتخاب کنید. همچنین برای اهداف خاص مانند پشتیبان‌گیری، بازیابی پس از بحران (DR) یا توزیع بار، امکان استفاده از مراکز داده واقع در سایر استان‌ها فراهم است تا انعطاف‌پذیری و تداوم سرویس تضمین شود.",
  },
  {
    title:
      "مزیت استفاده از خدمات دیتاسنتر آبالون نسبت به نگهداری داخلی تجهیزات چیست؟",
    answer:
      "با خدمات دیتاسنتر آبالون نیازی به سرمایه‌گذاری سنگین روی زیرساخت داخلی ندارید. برق پایدار، سیستم‌های کولینگ پیشرفته، امنیت چند لایه و مانیتورینگ مداوم در اختیار شماست و تیم پشتیبانی ۲۴/۷ آبالون، دسترس‌پذیری مداوم و عملکرد بهینه تجهیزات را تضمین می‌کند.",
  },
];
